module.exports = __webpack_public_path__ + "static/media/1006103.a4a301ad.png";